angular.module('rentalListingModule', ['rentalListingTemplates']);

angular.module('rentalListingModule').constant('rentalListingVariables', {
	'pricePattern': /^(\d*([.,](?=\d{3}))?\d+)+((?!\2)[.,]\d\d)?$/
});
